import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../models/RoutesModel';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-main">
      <div className="title">Page Not Found</div>
      <div className="back" onClick={() => navigate(`${RoutesEnum.LANDING}`)}>Back to Home</div>
    </div>
  )
}

export default NotFoundPage

{/**
import React, { useMemo, useState } from "react";
import EyeIcon from "../images/eye-switch.svg";
import MainLogo from "../images/login-logo.svg"
import "../scss/login.scss";
import { folderNameRegex } from "../helpers/RegexHelpers";
import { setToSession } from "../helpers/GenericHelpers";

const LoginPage = () => {
  // Todo: remove from here
  enum fieldType {
    TEXT = "text",
    PASSWORD = "password",
  }

  interface IInputValuesModel {
    username: string,
    password: string,
  }

  // states
  const [type, setType] = useState(fieldType.PASSWORD);

  const [error, setError] = useState("");

  const [inputValues, setInputValues] = useState<IInputValuesModel>({
    username: '',
    password: ''
  })

  // helpers
  const toogleType = () =>
    setType((prev) =>
      prev === fieldType.TEXT ? fieldType.PASSWORD : fieldType.TEXT
    );

  const handleChange = (value: string, field: string) => {
    setInputValues(prev => ({ ...prev, [field]: value }))
  } 

  const validateUserName = (value: string) => {
    if (value?.match(folderNameRegex)) {
      setError('')
    } else setError('Only alphabets, 0-9, "_" are allowed for Username')
  }

  const signInDisabled = useMemo(() => {
    if (error || inputValues?.username?.length < 5 || inputValues?.password?.length < 5) return true
    else return false
  }, [error, inputValues])

  // apis 
  const signInSubmit = () => {
    setToSession('user_name', inputValues?.username)
    window.location.href = '/landing'
  }

  return (
    <div className="login-main">
      <div className="login-form">
        <div className="main-logo">
          <img src={MainLogo} alt="MainLogo" className="logo-icon" />
          <div className="main-heading">Welcome Back!</div>
          <div className="sub-heading">Please log in. </div>

          <div className="form-main">
            { error ? <div className="erorr-message"></div> : <></>}

            <input type="text" name="" id="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
 */}